// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NNwO","col":"styles_col__30nPD"};